/**
 * @generated SignedSource<<96746cea6cf239e087e7e392cf42c8b9>>
 * @relayHash cb3c41cbaf23c47e101ab3a548ae5fc7
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cb3c41cbaf23c47e101ab3a548ae5fc7

import type { ConcreteRequest } from 'relay-runtime';
export type ArtifactsSectionQuery$variables = {
  id: string;
};
export type ArtifactsSectionQuery$data = {
  readonly node: {
    readonly databaseId?: number | null | undefined;
  } | null | undefined;
};
export type ArtifactsSectionQuery = {
  response: ArtifactsSectionQuery$data;
  variables: ArtifactsSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArtifactsSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArtifactsSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "cb3c41cbaf23c47e101ab3a548ae5fc7",
    "metadata": {},
    "name": "ArtifactsSectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "be7625e96f92ba86c631f6cea0877473";

export default node;
